import { NgModule } from '@angular/core';
import { AgrSharedModule } from '@next/core-lib/shared';

import { CustomerSearchService } from './services/customer-search.service';

@NgModule({
  declarations: [],
  imports: [AgrSharedModule],
  exports: [AgrSharedModule],
  providers: [
    // add shared services and guards here
    CustomerSearchService,
  ],
})
export class SharedModule {}
